import * as React from 'react';
import { Text } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';

const PaymentInstructionLayout = ({ info  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(Text, null, getLabel(info));
};

export { PaymentInstructionLayout };
//# sourceMappingURL=PaymentInstructionLayout.js.map
